export function useLocale(){return {lang:'tr' as string};}
